import { getBlankForm, getNewQuestionnaire, postBlankForm } from '@/entities/application/api/step2';
import { TSection } from '@ifr/form-questionnaire/src/types/Elements';
import { Module } from 'vuex';
import type ExtendedAxiosError from '@/entities/application/model/types/shared/ExtendAxiosError';
// import json from '@/features/application-review/ui/question-preview/json';

interface IStep2Store {
  json: TSection[];
}
export default <Module<IStep2Store, any>>{
  state: {
    json: [],
  },
  mutations: {
    setQuestionnaire(state, quest = []) {
      //@ts-ignore
      // state.json = json;
      state.json = quest;
    },
  },
  actions: {
    async saveStore({ rootGetters, dispatch }, json: TSection[]) {
      const id = rootGetters.appId;
      try {
        await postBlankForm(id, json);
      } catch (e: any) {
        const error = e as ExtendedAxiosError<null>;
        error.uri = rootGetters.uri.blankForm(id);
        dispatch('setError', error, { root: true });
        throw error;
      }
    },
    async getQuestionnaire({ commit, rootGetters }, isAppStore = false) {
      const id = rootGetters.appId;
      let response;
      if (isAppStore) {
        response = await getBlankForm(id);
      } else {
        let idN;
        const params = window.localStorage.getItem('survey');
        if (params) {
          idN = 'survey=' + params;
        }
        response = await getNewQuestionnaire(id, idN);
      }

      const { data = [] } = response;

      commit('setQuestionnaire', data);

      return response;
    },
  },
  getters: {
    isJson: (state): boolean => !!state.json.length,
    json: (state): TSection[] => state.json,
  },
};
